import * as e from "react";
const f = typeof window < "u" ? e.useLayoutEffect : e.useEffect, t = f;
export {
  t as u
};
//# sourceMappingURL=useEnhancedEffect-575b9875.js.map
